import { ReactElement } from 'react';
import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useMenuState } from '../../../../../components/DropdownMenu/MenuContext';
import { Icon, IconTypes } from '../../../../../components/Icon';
import { theme } from '../../../../../theme';

const Container = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const CloseIconWrapper = styled('div')`
  cursor: pointer;
`;

export const ColumnsSettingsHeader = (): ReactElement => {
  const { onClose } = useMenuState();

  return (
    <Container>
      <Typography variant='subtitle1' color={theme.colors.primary[100]}>
        Column Settings
      </Typography>
      <CloseIconWrapper onClick={onClose}>
        <Icon type={IconTypes.CLOSE_MENU_1} color={theme.colors.secondary[60]} />
      </CloseIconWrapper>
    </Container>
  );
};
